import {
  accountSearchColumns,
  khachHangSearchColumns,
  ngoaiTeSearchColumns,
  nhomColumns,
  QUERY_KEYS
} from '@/constants';
import { DateRangeDropdownV2, FormFieldV2, SearchFieldV2, UnitDropdownV2 } from '@/components/custom/erp';
import type { SearchFieldStates } from '../../hooks';
import { Label } from '@/components/ui/label';

const VOUCHER_TYPE_OPTIONS = [
  { value: 0, label: 'Tất cả' },
  { value: 1, label: 'Chưa phân bổ hết' },
  { value: 2, label: 'Đã phân bổ hết' }
];

const ALLOCATION_MODE_OPTIONS = [
  { value: 0, label: 'Người dùng tự phân bổ' },
  { value: 1, label: 'Gợi ý tự động theo ngày hóa đơn, số hóa đơn' },
  { value: 2, label: 'Gợi ý tự động theo hạn thanh toán, số hóa đơn' }
];

interface BasicInfoTabProps {
  searchFieldStates: SearchFieldStates;
}

const BasicInfoTab = ({ searchFieldStates }: BasicInfoTabProps) => (
  <div className='space-y-2 p-4'>
    <div className='flex flex-col space-y-3'>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Ngày từ/đến:</Label>
        <div className='w-[450px]'>
          <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
        </div>
      </div>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Ngoại tệ:</Label>
        <SearchFieldV2
          name='ma_nt'
          searchEndpoint={`/${QUERY_KEYS.NGOAI_TE}`}
          columnDisplay='ma_nt'
          displayRelatedField='ten_nt'
          searchColumns={ngoaiTeSearchColumns}
          onRowSelection={searchFieldStates.setNgoaiTe}
        />
      </div>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Tài khoản:</Label>
        <SearchFieldV2
          name='tk_co'
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={accountSearchColumns}
          columnDisplay='code'
          displayRelatedField='name'
          onRowSelection={searchFieldStates.setTaiKhoan}
        />
      </div>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Mã khách hàng:</Label>
        <SearchFieldV2
          name='ma_kh'
          searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}`}
          searchColumns={khachHangSearchColumns}
          columnDisplay='customer_code'
          displayRelatedField='customer_name'
          onRowSelection={searchFieldStates.setKhachHang}
        />
      </div>
      <div className='flex items-center'>
        <Label className='w-40 min-w-40'>Nhóm khách hàng:</Label>
        <div className='flex flex-1 gap-1'>
          <SearchFieldV2
            name='nh_kh1'
            searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=KH1`}
            columnDisplay='ma_nhom'
            searchColumns={nhomColumns}
            onRowSelection={searchFieldStates.setNhomKhachHang1}
            className='w-48'
          />
          <SearchFieldV2
            name='nh_kh2'
            searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=KH2`}
            columnDisplay='ma_nhom'
            searchColumns={nhomColumns}
            onRowSelection={searchFieldStates.setNhomKhachHang2}
            className='w-48'
          />
          <SearchFieldV2
            name='nh_kh3'
            searchEndpoint={`/${QUERY_KEYS.NHOM}?loai_nhom=KH3`}
            columnDisplay='ma_nhom'
            searchColumns={nhomColumns}
            onRowSelection={searchFieldStates.setNhomKhachHang3}
            className='w-48'
          />
        </div>
      </div>
      <UnitDropdownV2 formMode='add' name='unit_id' labelClassName='w-40 min-w-40' />
      <FormFieldV2
        name='pb_yn'
        label='Loại phiếu thu'
        labelClassName='w-36'
        type='select'
        options={VOUCHER_TYPE_OPTIONS}
      />
      <FormFieldV2 name='xu_ly' label='Xử lí' labelClassName='w-36' type='select' options={ALLOCATION_MODE_OPTIONS} />
      <div className='ml-40 flex items-center'>
        <FormFieldV2 name='xl_pb_yn' type='checkbox' />
        <Label>Tự động lưu phân bổ theo gợi ý</Label>
      </div>
    </div>
  </div>
);

export default BasicInfoTab;
